import { Dropdown, Space } from 'antd';
import { default as enUS } from 'antd/locale/en_US';
import { default as jaJP } from 'antd/locale/ja_JP';
import { default as zhCN } from 'antd/locale/zh_CN';
import { default as zhHK } from 'antd/locale/zh_HK';
import { Icons } from '../icons';
import styles from './style.module.less';
import type { LanguageProps } from './types';

import type { MenuProps } from 'antd';
import type { ReactElement } from 'react';

export function LangSwitch({ color = 'white', lang = 'zh_cn', onChange }: LanguageProps): ReactElement {
  const onClick: MenuProps['onClick'] = ({ key }) => {
    onChange?.(key);
    window.location.reload();
  };

  return (
    <Dropdown menu={{ items: Object.values(Langs), onClick }}>
      <Space size={4}>
        <Icons name='GlobalOutlined' style={{ color }} />
        <span className={styles.language} style={{ color }}>
          {Object.values(Langs).find(item => item.key === lang)?.label}
        </span>
        <Icons name='CaretDownOutlined' />
      </Space>
    </Dropdown>
  );
}

export const Langs = {
  zh_cn: { key: 'zh_cn', label: '简体中文', locale: zhCN },
  zh_hk: { key: 'zh_hk', label: '繁體中文', locale: zhHK },
  jp: { key: 'jp', label: '日本語', locale: jaJP },
  en: { key: 'en', label: 'English', locale: enUS }
};
